import { render, staticRenderFns } from "./infos.vue?vue&type=template&id=5adcc1ad&scoped=true&"
import script from "./infos.vue?vue&type=script&lang=js&"
export * from "./infos.vue?vue&type=script&lang=js&"
import style0 from "./infos.vue?vue&type=style&index=0&id=5adcc1ad&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adcc1ad",
  null
  
)

export default component.exports